import {
  OrderCargoOrderDetailsCargoOrderRideSeqNode,
  OrderCargoOrderDetailsCargoOrderRideSeqNodeSet,
} from "../../../../../common/services/order/cargo-order/details/order-cargo-order-details";
import OrderRouteEditPassenger, {
  OrderRouteEditInternalPassenger,
  OrderRouteEditPassengerType,
} from "../types/order-route-edit-passenger";
import OrderRouteEditRouteItem, {
  OrderRouteEditRouteWaypoint,
  OrderRouteEditRouteWaypointGroup,
} from "../types/order-route-edit-route-waypoint";

const checkIsRouteItemAWaypoint = (
  routeItem: OrderRouteEditRouteItem,
): routeItem is OrderRouteEditRouteWaypoint => {
  if ((routeItem as OrderRouteEditRouteWaypoint).date !== undefined) {
    return true;
  }

  return false;
};

const checkIsRouteItemWaypointGroup = (
  routeItem: OrderRouteEditRouteItem,
): routeItem is OrderRouteEditRouteWaypointGroup => {
  if ((routeItem as OrderRouteEditRouteWaypointGroup).waypoints) {
    return true;
  }

  return false;
};

const checkIsSingleNode = (
  node:
    | OrderCargoOrderDetailsCargoOrderRideSeqNode
    | OrderCargoOrderDetailsCargoOrderRideSeqNodeSet,
): node is OrderCargoOrderDetailsCargoOrderRideSeqNode => {
  return (
    (node as OrderCargoOrderDetailsCargoOrderRideSeqNodeSet).seq === undefined
  );
};

const checkIsInternalPassenger = (
  passenger: OrderRouteEditPassenger,
): passenger is OrderRouteEditInternalPassenger => {
  return passenger.type === OrderRouteEditPassengerType.INTERNAL;
};

const checkIsRouteItemsPastDate = (
  routes: OrderRouteEditRouteItem[],
): boolean => {
  let currentDate = new Date();

  return routes
    .filter((x) => (x as OrderRouteEditRouteWaypoint).date != null)
    .some((x) => (x as OrderRouteEditRouteWaypoint).date! < currentDate);
};

const orderRouteEditHelper = {
  checkIsRouteItemAWaypoint,
  checkIsRouteItemWaypointGroup,
  checkIsSingleNode,
  checkIsInternalPassenger,
  checkIsRouteItemsPastDate,
};

export default orderRouteEditHelper;
